/**
 * przekazanie-zdjec.js — sprzątanie starych przekazań zdjęć do Edytora (`lf_batch_<uuid>`).
 *
 * Porządki LF faza 6 (2026-09-16). Ta sama pętla stała w TRZECH miejscach (Studio „Edytuj
 * zaznaczone", Studio auto-edycja, Galeria „Do Studia") i w każdym kasowała KAŻDY wpis
 * zaczynający się od `lf_batch_`, który nie wyglądał na przekazanie. Pod tym przedrostkiem żyją
 * też ustawienia innych ekranów — zmierzone w kodzie:
 *   - `lf_batch_mask_main_engine_v3` (Edytor: wybrany silnik maski, zwykły napis),
 *   - `lf_batch_mask_job`            (Edytor: numer trwającej maski wsadowej — powrót po F5),
 *   - `lf_batch_styles`              (Kolejka: zapamiętany styl, tablica JSON bez `created`).
 * Każde „Edytuj zaznaczone" po cichu je zerowało.
 *
 * 🔑 ZASADA: usuwamy TYLKO to, co rozpoznajemy jako nasze przekazanie (obiekt z tablicą
 * `photoRefs`), gdy nie ma `created` albo minęło 24 h (kontrakt GOLD galeria-3-bg-flow R5.2).
 * Wpis nieczytelny albo o innym kształcie NIE jest nasz — zostaje. Wolimy zostawić śmieć niż
 * skasować komuś ustawienie.
 *
 * Ładowanie: zwykły <script> (Galeria) albo `import` w paczce Studia — oba ustawiają
 * `globalThis.LFPrzekazanie`. Kontrola zachowania: `node .tools/test-przekazanie-zdjec.mjs`.
 */
(function (glob) {
  var PRZEDROSTEK = 'lf_batch_';
  var TTL_MS = 24 * 60 * 60 * 1000;

  function toNaszePrzekazanie(wartosc) {
    return !!wartosc && typeof wartosc === 'object' && Array.isArray(wartosc.photoRefs);
  }

  /** Usuwa przeterminowane przekazania. Zwraca liczbę usuniętych (dla testu). */
  function sprzatnijStare(magazyn, teraz) {
    var usuniete = 0;
    for (var i = magazyn.length - 1; i >= 0; i--) {
      var k = magazyn.key(i);
      if (!k || k.indexOf(PRZEDROSTEK) !== 0) continue;
      var v;
      try { v = JSON.parse(magazyn.getItem(k)); } catch (e) { continue; }
      if (!toNaszePrzekazanie(v)) continue;
      if (!v.created || (teraz - v.created) > TTL_MS) {
        magazyn.removeItem(k);
        usuniete++;
      }
    }
    return usuniete;
  }

  glob.LFPrzekazanie = { sprzatnijStare: sprzatnijStare, PRZEDROSTEK: PRZEDROSTEK, TTL_MS: TTL_MS };
})(typeof globalThis !== 'undefined' ? globalThis : window);
